import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'react-bootstrap';
import QuestionsContainer from '../common/QuestionsContainer';
import { postRequest } from '../../requestUtils';
import logoImg from '../../../assets/images/Logo_Gray.svg';
import './ProjectLead.scss';
var ProjectLead = /*#__PURE__*/function (_Component) {
  function ProjectLead(props) {
    var _this;
    _classCallCheck(this, ProjectLead);
    _this = _callSuper(this, ProjectLead, [props]);
    _this.state = {
      currentPage: 1
    };
    _this.renderQuestion = _this.renderQuestion.bind(_this);
    _this.renderFooter = _this.renderFooter.bind(_this);
    _this.previousPage = _this.previousPage.bind(_this);
    _this.nextPage = _this.nextPage.bind(_this);
    _this.sendAnswers = _this.sendAnswers.bind(_this);
    return _this;
  }
  _inherits(ProjectLead, _Component);
  return _createClass(ProjectLead, [{
    key: "sendAnswers",
    value: function sendAnswers() {
      var _this$props = this.props,
        projectLeadUrl = _this$props.projectLeadUrl,
        csrfToken = _this$props.csrfToken,
        questionableId = _this$props.questionableId,
        afterSubmit = _this$props.afterSubmit;
      this.nextPage();
      postRequest(projectLeadUrl, {
        survey_id: questionableId
      }, csrfToken).then(function () {
        return afterSubmit();
      });
    }
  }, {
    key: "previousPage",
    value: function previousPage() {
      var currentPage = this.state.currentPage;
      this.setState({
        currentPage: currentPage - 1
      });
    }
  }, {
    key: "nextPage",
    value: function nextPage() {
      var currentPage = this.state.currentPage;
      this.setState({
        currentPage: currentPage + 1
      });
    }
  }, {
    key: "renderProgressBar",
    value: function renderProgressBar() {
      var questionnaireQuestions = this.props.questionnaireQuestions;
      var currentPage = this.state.currentPage;
      var max = Object.keys(questionnaireQuestions).length;
      return /*#__PURE__*/React.createElement("div", {
        className: "progress-bar-container"
      }, /*#__PURE__*/React.createElement(ProgressBar, {
        now: currentPage,
        max: max
      }), /*#__PURE__*/React.createElement("span", {
        className: "progress-text body-text-3"
      }, currentPage, "/", max));
    }
  }, {
    key: "renderQuestion",
    value: function renderQuestion() {
      var currentPage = this.state.currentPage;
      var _this$props2 = this.props,
        questionnaireQuestions = _this$props2.questionnaireQuestions,
        questionableId = _this$props2.questionableId,
        questionableType = _this$props2.questionableType,
        csrfToken = _this$props2.csrfToken;
      var questionnaireQuestionIds = questionnaireQuestions[currentPage].map(function (x) {
        return x.id;
      });
      return /*#__PURE__*/React.createElement("div", {
        key: currentPage
      }, /*#__PURE__*/React.createElement(QuestionsContainer, {
        questionIds: questionnaireQuestionIds,
        questionableId: questionableId,
        questionableType: questionableType,
        csrfToken: csrfToken,
        forceSmallQuestionTitle: true,
        owner: true
      }));
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      var _this2 = this;
      var questionnaireQuestions = this.props.questionnaireQuestions;
      var currentPage = this.state.currentPage;
      if (currentPage <= 1) {
        return /*#__PURE__*/React.createElement("button", {
          className: "btn btn-primary next-btn",
          onClick: function onClick() {
            return _this2.nextPage();
          }
        }, "Next", /*#__PURE__*/React.createElement("i", {
          className: "ms-2 fa fa-chevron-right"
        }));
      }
      if (currentPage > 1 && currentPage < Object.keys(questionnaireQuestions).length) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
          className: "btn btn-primary-mute back-btn",
          onClick: function onClick() {
            return _this2.previousPage();
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-chevron-left"
        })), /*#__PURE__*/React.createElement("button", {
          className: "btn btn-primary next-btn",
          onClick: function onClick() {
            return _this2.nextPage();
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-chevron-right"
        })));
      }
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary-mute back-btn",
        onClick: function onClick() {
          return _this2.previousPage();
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-chevron-left"
      })), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary project-lead-send-answers",
        onClick: function onClick() {
          return _this2.sendAnswers();
        }
      }, "Send answers"));
    }
  }, {
    key: "render",
    value: function render() {
      var questionnaireQuestions = this.props.questionnaireQuestions;
      var currentPage = this.state.currentPage;
      if (currentPage <= Object.keys(questionnaireQuestions).length) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: "logo"
        }, /*#__PURE__*/React.createElement("img", {
          src: logoImg,
          alt: "Clora"
        })), currentPage === 1 && /*#__PURE__*/React.createElement("div", {
          className: "body-text-2 mt-4"
        }, "These answers will allow Clora to tailor the right demo for your organization:"), this.renderProgressBar(), this.renderQuestion(), /*#__PURE__*/React.createElement("div", {
          className: "navigation"
        }, this.renderFooter()));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "info-sent"
      }, /*#__PURE__*/React.createElement("div", {
        className: "logo"
      }, /*#__PURE__*/React.createElement("img", {
        src: logoImg,
        alt: "Clora"
      })), /*#__PURE__*/React.createElement("h2", null, "Your information has been sent!"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, "A copy of your answers was sent to your inbox. Clora will contact you shortly to let you know more about our services!"));
    }
  }]);
}(Component);
ProjectLead.propTypes = {
  questionnaireQuestions: PropTypes.shape({}).isRequired,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  projectLeadUrl: PropTypes.string.isRequired,
  afterSubmit: PropTypes.func
};
ProjectLead.defaultProps = {
  afterSubmit: function afterSubmit() {}
};
export default ProjectLead;